/** Normalise une chaîne pour recherche accent-insensible */
const normalize = (s) =>
  (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export default normalize;
